import { INewbuildingMapPin } from '../../types/map';
import {
  IMapRow,
  INewbuildingSummaryRow,
  INewbuildingsCompareBlock,
  ITransportPointExtendedRow,
  TNewbuildingsCompareRow,
} from '../../types/newbuildingsCompare';

function isTransportPointExtendedRow(row: TNewbuildingsCompareRow): row is ITransportPointExtendedRow {
  return row.type === 'transportPointExtended';
}

/**
 * Собирает пины ЖК для карты: строка `map` отдаёт только заголовок пина и координаты, поэтому
 * остальные данные для превью-карточки берём из строк `newbuildingSummary` и `transportPointExtended`
 * по индексу колонки.
 */
export function collectMapPins(
  mapRow: IMapRow,
  summaryRow: INewbuildingSummaryRow | undefined,
  blocks: INewbuildingsCompareBlock[],
): INewbuildingMapPin[] {
  if (!summaryRow) {
    return [];
  }

  const transportRow = blocks.flatMap(block => block.rows).find(isTransportPointExtendedRow);

  return mapRow.cells.reduce<INewbuildingMapPin[]>((pins, cell, index) => {
    const newbuilding = summaryRow.cells[index]?.data;

    if (!cell.data || !newbuilding) {
      return pins;
    }

    pins.push({
      title: cell.data.title,
      coordinates: cell.data.coordinates,
      newbuilding,
      transportPoint: transportRow?.cells[index]?.data?.transportPoints?.[0],
    });

    return pins;
  }, []);
}
